import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c9b6f4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container d-flex flex-column justify-content-between align-items-stretch h-100" }
const _hoisted_2 = {
  key: 1,
  class: "card d-inline-block text-start"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Login")
], -1))
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "form-group mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_7 = { class: "form-group mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-footer text-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Login")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Center = _resolveComponent("Center")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_ctx.error)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            modelValue: _ctx.error,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.error) = $event)),
            class: "alert-danger"
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Center, null, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Spinner, {
              key: 0,
              size: "8rem",
              thickness: "1.25rem"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("form", {
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
              }, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      class: "form-control",
                      id: "email",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.email]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      class: "form-control",
                      id: "password",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.password]
                    ])
                  ])
                ]),
                _hoisted_9
              ], 32)
            ]))
      ]),
      _: 1
    }),
    _hoisted_10
  ]))
}